import React from 'react';
import './Start.css';

const BackToMainMenu = (obj: any) => {
	return (
		<div className="ui-container start-container modal-disable-select">
			<div className="ui-inner-container">
				<button onClick={obj.parameters.onDone}>MainMenu</button>
			</div>
			
		</div>
	);
};

export default BackToMainMenu;
